/**
 * Profile Image
 */
export const SmileList = (function () {

    let init = function () {
      $('.smile-list-containers svg').on('click', function(){
        $('.smile-list-containers svg').removeClass('selected');
        $(this).toggleClass('selected');
        var key = $(this).attr('data-attr-key');
        var val = $(this).attr('data-attr-value');
        $('#'+key+'-value').val(val);
      });
    }
 
  
    return {
      init: init
    }
  
  }());